import { css } from 'styled-components'
import { contentWidth, media } from './tokens'

/** The chrome's side gutters: 36px on desktop, 18px once the bento grid collapses. */
export const shellGutter = {
	wide: '36px',
	narrow: '18px',
} as const

/**
 * The shared horizontal geometry for every top-level surface — the member and
 * public navbar rows, the breadcrumb trail, and every page's PageColumn — so
 * their left and right edges line up on desktop. Centers a `contentWidth`
 * column with the shell gutters. Vertical padding stays per-surface: on the
 * chrome, the full-bleed outer element owns it; this mixin only sets the column
 * and its gutters. Kept here as the single source so the chrome can never drift
 * from the content column again (the mismatch this replaced was a 1200px navbar
 * over a 1400px page).
 */
export const contentShell = css`
	max-width: ${contentWidth};
	margin-left: auto;
	margin-right: auto;
	padding-left: ${shellGutter.wide};
	padding-right: ${shellGutter.wide};

	${media.bentoCollapse} {
		padding-left: ${shellGutter.narrow};
		padding-right: ${shellGutter.narrow};
	}
`
